export default __webpack_public_path__ + "static/media/Chalten30.dba58900.jpg";